import React from 'react';
import { Quote, Heart } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block text-[11px] font-semibold tracking-widest text-[#B08D3C] px-3 py-1 border border-[#B08D3C]/40 rounded-full">
              LO QUE DICEN DE NOSOTROS
            </span>
            <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-[#1E3A5F]">
              Historias que nos{' '}
              <span className="text-[#9B2C3B] italic">inspiran.</span>
            </h2>
          </div>
          <Heart className="hidden md:block h-8 w-8 text-[#E8B84A]" fill="currentColor" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="rounded-2xl p-7 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
              style={{ backgroundColor: t.color }}
            >
              <Quote className="h-6 w-6 text-[#9B2C3B]" fill="currentColor" />
              <p className="mt-5 font-serif text-[18px] leading-snug text-[#1E3A5F]">
                {t.text}
              </p>
              <div className="mt-6 text-[12px] font-semibold text-[#1E3A5F]/70">
                {t.author}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
